import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=40bf027c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=40bf027c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bf027c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bf027c')) {
      api.createRecord('40bf027c', component.options)
    } else {
      api.reload('40bf027c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=40bf027c&scoped=true&", function () {
      api.rerender('40bf027c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RDsWZB1Iwlrr/JS/comp/PopupDialog.vue"
export default component.exports